<template>
  <div class="flickity__holder">
    <div ref="root" class="flickity">
      <slot />
    </div>
    <div class="flickity-controls">
      <div class="prev-nex-buttons">
        <button class="button button--previous" @click="goToPrevious" aria-label="Previous Slide">
          <arrow-right/>
        </button>
        <button class="button button--next" @click="goToNext" aria-label="Next Slide">
          <arrow-right/>
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, onUnmounted, ref } from 'vue'
import Flickity from 'flickity'

import ArrowRight from "./svg/ArrowRight.vue"
import ArrowLeft from "./svg/ArrowLeft.vue"

export default defineComponent({
  props: {
    options: Object,
  },
  components: {
    ArrowLeft,
    ArrowRight,
  },
  setup(props) {
    let flickityCarousel: Flickity | null = null
    const root = ref<HTMLElement | null>(null)
    // const progressBar = ref<HTMLElement | null>(null)

    onMounted(() => {
      flickityCarousel = new Flickity(root.value as HTMLElement, props.options)
      // updateProgress()
      // flickityCarousel.on('select', updateProgress)
    })

    onUnmounted(() => {
      // flickityCarousel?.off('select', updateProgress)
      flickityCarousel?.destroy()
    })

    const goToPrevious = () => {
      if (flickityCarousel) {
        flickityCarousel!.previous()
      }
    }

    const goToNext = () => {
      if (flickityCarousel) {
        flickityCarousel!.next()
      }
    }

    return {
      root,
      goToPrevious,
      goToNext,
      // progressBar,
    }
  },
})
</script>

<style scoped>
@import '~flickity/dist/flickity.css';
</style>
